import { useCallback, useState } from 'react';

type UseEndorsementsBannerReturn = ModelHookResult<{ isDismissed: boolean }, { handleDismiss: () => void }>;

export function useEndorsementsBanner(): UseEndorsementsBannerReturn {
	const [isDismissed, setIsDismissed] = useState(false);

	const handleDismiss = useCallback(() => {
		setIsDismissed(true);
	}, []);

	return {
		data: { isDismissed },
		actions: { handleDismiss },
	};
}
